import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Chip from '@/components/Chip';
import { MEDIA_EXAMPLE, SUBJECTS_EXAMPLE } from '@/domain/integration/utils';
import { useTranslate } from '@/state/i18n';
import { radiusTokens } from '@/theme/themePrimitives';

/** "Como integrar": the two calls of `/media-partners/v1` and the rules of the contract. */
const IntegrationDocs = () => {
  const t = useTranslate('domain.integration.components.IntegrationDocs');

  return (
    <Paper variant="outlined" sx={sx.paper}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1}>
        <Typography variant="subtitle2" fontWeight={700}>
          {t('title')}
        </Typography>
        <Chip size="xsmall" variant="outline" color="neutral" label={t('version')} />
      </Stack>

      <Step n="01" title={t('subjects.title')} text={t('subjects.text')} code={SUBJECTS_EXAMPLE} />
      <Step n="02" title={t('media.title')} text={t('media.text')} code={MEDIA_EXAMPLE} />

      <Stack gap={1}>
        <Typography variant="subtitle2">{`03 · ${t('rules.title')}`}</Typography>
        <Box component="ul" sx={sx.list}>
          <li>{t('rules.threshold')}</li>
          <li>{t('rules.preview')}</li>
          <li>{t('rules.usage')}</li>
          <li>{t('rules.auth')}</li>
        </Box>
      </Stack>
    </Paper>
  );
};

export default IntegrationDocs;

const Step = ({
  n,
  title,
  text,
  code,
}: {
  n: string;
  title: string;
  text: string;
  code: string;
}) => (
  <Stack gap={1}>
    <Typography variant="subtitle2">{`${n} · ${title}`}</Typography>
    <Typography variant="body2" color="text.secondary">
      {text}
    </Typography>
    <Box component="pre" sx={sx.code}>
      {code}
    </Box>
  </Stack>
);

const sx = {
  paper: {
    borderRadius: radiusTokens.xxl,
    p: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 2.5,
  },
  code: {
    m: 0,
    p: 2,
    borderRadius: radiusTokens.xl,
    bgcolor: 'action.hover',
    fontFamily: 'monospace',
    fontSize: 12,
    lineHeight: 1.6,
    overflowX: 'auto',
    whiteSpace: 'pre',
  },
  list: { m: 0, pl: 2.5, typography: 'body2', color: 'text.secondary', '& li + li': { mt: 0.75 } },
};
